module.exports = __webpack_public_path__ + "media/images/question-9794910167292f9c543cd88678f60518.svg";